export default {
  'storeManagement.title': '店铺列表',
  'storeManagement.form.merchantName': '商户名称',
  'storeManagement.form.merchantName.placeholder': '请输入商户名称',
  'storeManagement.form.shopName': '店铺名称',
  'storeManagement.form.shopName.placeholder': '请输入店铺名称',
  'storeManagement.form.search': '查询',
  'storeManagement.form.reset': '重置',
  'storeManagement.operation.add': '新增',
  'storeManagement.operation.editMerchant': '修改商户',
  'storeManagement.operation.delete': '删除',
  'storeManagement.operation.export': '导出',
  'storeManagement.operation.batchDeleteConfirm': '确定要删除选中的店铺吗？',
  'storeManagement.operation.noSelection': '请先选择要操作的店铺',
  'storeManagement.operation.batchDeleteSuccess': '批量删除成功',
  'storeManagement.operation.batchDeleteFailed': '批量删除失败',
  'storeManagement.operation.restore': '恢复',
  'storeManagement.operation.batchRestoreConfirm': '确定要恢复选中的店铺吗？',
  'storeManagement.operation.batchRestoreSuccess': '批量恢复成功',
  'storeManagement.operation.batchRestoreFailed': '批量恢复失败',
  'storeManagement.columns.index': '#',
  'storeManagement.columns.merchantName': '商户名称',
  'storeManagement.columns.shopName': '店铺名称',
  'storeManagement.columns.shopifyId': 'Shopify ID',
  'storeManagement.columns.operationName': '运营名称',
  'storeManagement.columns.shopApi': '店铺API',
  'storeManagement.columns.paypalApi': 'Paypal配置',
  'storeManagement.columns.ccApi': '信用卡配置',
  'storeManagement.columns.scApi': '续费信用卡配置',
  'storeManagement.columns.walletApi': '钱包配置',
  'storeManagement.columns.upsellSetting': 'Upsell配置',
  'storeManagement.columns.status': '状态',
  'storeManagement.columns.status.enabled': '已启用',
  'storeManagement.columns.status.disabled': '未安装',
  'storeManagement.columns.remarks': '备注',
  'storeManagement.columns.createdAt': '创建时间',
  'storeManagement.columns.updatedAt': '更新时间',
  'storeManagement.columns.notConfigured': '未配置',
  'storeManagement.columns.operations': '操作',
  'storeManagement.columns.operations.edit': '编辑',
  'storeManagement.columns.operations.delete': '删除',
  'storeManagement.columns.operations.deleteConfirm': '确定要删除这条记录吗？',
  'storeManagement.columns.operations.restore': '恢复',
  'storeManagement.columns.operations.restoreConfirm': '确定要恢复该店铺吗？恢复后将回到删除前的状态。',
  'storeManagement.columns.storeType': '店铺类型',
  'storeManagement.columns.storeType.normal': '正常店铺',
  'storeManagement.columns.storeType.backup': '备用店铺',
  'storeManagement.columns.configured': '已配置',
  'storeManagement.actions.refresh': '刷新',
  'storeManagement.actions.density': '密度',
  'storeManagement.actions.columnSetting': '列设置',
  'storeManagement.operation.download': '下载',
  'storeManagement.size.mini': '迷你',
  'storeManagement.size.small': '偏小',
  'storeManagement.size.medium': '中等',
  'storeManagement.size.large': '偏大',
  'storeManagement.modal.title': '店铺信息',
  'storeManagement.modal.shopName': '店铺名称',
  'storeManagement.modal.shopName.placeholder': '请输入店铺名称',
  'storeManagement.modal.shopName.required': '请输入店铺名称',
  'storeManagement.modal.merchant': '所属商户',
  'storeManagement.modal.merchant.placeholder': '请输入所属商户',
  'storeManagement.modal.merchant.required': '请选择所属商户',
  'storeManagement.modal.shopifyId': 'Shopify ID',
  'storeManagement.modal.shopifyId.placeholder': '请输入 Shopify ID',
  'storeManagement.modal.shopifyId.required': '请输入 Shopify ID',
  'storeManagement.modal.remarks': '备注',
  'storeManagement.modal.remarks.placeholder': '请输入备注信息',
  'storeManagement.modal.createSuccess': '创建成功',
  'storeManagement.modal.createFailed': '创建失败',
  'storeManagement.shopApiModal.title': '店铺API',
  'storeManagement.shopApiModal.appName': '店铺名称',
  'storeManagement.shopApiModal.appName.placeholder': '请输入店铺名称',
  'storeManagement.shopApiModal.appName.required': '请输入店铺名称',
  'storeManagement.shopApiModal.adminApiAccessToken': 'Admin Token',
  'storeManagement.shopApiModal.adminApiAccessToken.placeholder':
    '安装应用自动填充,无需填写',
  'storeManagement.shopApiModal.storefrontApiAccessToken': 'Storefront Token',
  'storeManagement.shopApiModal.storefrontApiPrivateToken': 'Storefront Private Token',
  'storeManagement.shopApiModal.storefrontApiAccessToken.placeholder':
    '请输入 Storefront Token',
  'storeManagement.shopApiModal.storefrontApiPrivateToken.placeholder':
    '请输入 Storefront Private Token',
  'storeManagement.shopApiModal.clientId': 'Partner Client ID',
  'storeManagement.shopApiModal.clientId.placeholder':
    '请输入 Partner Client ID',
  'storeManagement.shopApiModal.clientId.required': '请输入 Partner Client ID',
  'storeManagement.shopApiModal.clientSecret': 'Partner Client Secret',
  'storeManagement.shopApiModal.clientSecret.placeholder':
    '请输入 Partner Client Secret',
  'storeManagement.shopApiModal.clientSecret.required':
    '请输入 Partner Client Secret',
  'storeManagement.shopApiModal.merchant': '所属商户',
  'storeManagement.shopApiModal.merchant.placeholder': '请输入所属商户',
  'storeManagement.shopApiModal.merchant.required': '请选择所属商户',
  'storeManagement.shopApiModal.googlePlacesApiKey': 'Google Places Key',
  'storeManagement.shopApiModal.googlePlacesApiKey.placeholder':
    '请输入 Google Places Key',
  'storeManagement.shopApiModal.appStatus': '应用状态',
  'storeManagement.shopApiModal.appStatus.placeholder': '请选择状态',
  'storeManagement.shopApiModal.appStatus.enabled': '已启用',
  'storeManagement.shopApiModal.appStatus.disabled': '未安装',
  'storeManagement.shopApiModal.appStatus.installHint':
    '仅未安装状态才能安装店铺，未安装无法手动改成已启用',
  'storeManagement.shopApiModal.saveSuccess': '保存成功',
  'storeManagement.shopApiModal.saveFailed': '保存失败',
  'storeManagement.shopApiModal.deleteSuccess': '删除成功',
  'storeManagement.shopApiModal.deleteFailed': '删除失败',
  'storeManagement.shopApiModal.deleteConfirm': '是否确定清除店铺配置？',
  'storeManagement.paymentModal.paypal.title': 'Paypal配置',
  'storeManagement.paymentModal.card.title': '信用卡配置',
  'storeManagement.paymentModal.scCard.title': '续费信用卡配置',
  'storeManagement.paymentModal.wallet.title': '钱包配置',
  'storeManagement.paymentModal.upsell.title': 'Upsell配置',
  'storeManagement.editMerchantModal.title': '批量编辑商户',
  'storeManagement.editMerchantModal.merchant': '选择商户',
  'storeManagement.editMerchantModal.merchant.placeholder': '请选择商户',
  'storeManagement.editMerchantModal.merchant.required': '请选择商户',
  'storeManagement.editMerchantModal.noSelection': '请先选择要编辑的店铺',
  'storeManagement.editMerchantModal.success': '批量编辑成功',
  'storeManagement.editMerchantModal.failed': '批量编辑失败',
  'storeManagement.deleteSuccess': '删除成功',
  'storeManagement.deleteFailed': '删除失败',
  'storeManagement.restoreSuccess': '恢复成功',
  'storeManagement.restoreFailed': '恢复失败',
  'storeManagement.columns.email': '邮箱配置',
  'storeManagement.emailModal.title': '邮箱配置',
  'storeManagement.emailModal.formEmail': '发件邮箱',
  'storeManagement.emailModal.formEmail.required': '请输入发件邮箱',
  'storeManagement.emailModal.emailKey': '邮箱密钥',
  'storeManagement.emailModal.emailKey.required': '请输入邮箱密钥',
  'storeManagement.emailModal.password': '密码',
  'storeManagement.emailModal.password.required': '请输入密码',
  'storeManagement.emailModal.port': '端口',
  'storeManagement.emailModal.port.required': '请输入端口',
  'storeManagement.emailModal.host': '主机',
  'storeManagement.emailModal.host.required': '请输入主机',
  'storeManagement.emailModal.ssl': 'SSL',
  'storeManagement.emailModal.ssl.required': '请选择SSL',
  'storeManagement.emailModal.tls': 'TLS',
  'storeManagement.emailModal.tls.required': '请选择TLS',
  'storeManagement.emailModal.username': '用户名',
  'storeManagement.emailModal.username.required': '请输入用户名',
  'storeManagement.emailModal.saveSuccess': '保存成功',
  'storeManagement.emailModal.saveFailed': '保存失败',
  'storeManagement.emailModal.deleteSuccess': '删除成功',
  'storeManagement.emailModal.deleteFailed': '删除失败',
  'storeManagement.emailModal.deleteConfirm': '是否确定删除邮箱配置？',
  'storeManagement.emailModal.edit': '编辑',
  'storeManagement.emailModal.delete': '删除',
  'storeManagement.emailModal.protocol': '协议',
  'storeManagement.emailModal.protocol.required': '请选择协议',
  'storeManagement.emailModal.acceptEmail': '接收邮箱',
  'storeManagement.emailModal.acceptEmail.required': '请输入接收验证码的邮箱',
  'storeManagement.emailModal.acceptEmail.invalid': '请输入有效的邮箱地址',
  'storeManagement.emailModal.verifyCode': '验证码',
  'storeManagement.emailModal.verifyCode.required': '请输入验证码',
  'storeManagement.emailModal.sendCode': '发送验证码',
  'storeManagement.emailModal.verify': '验证',
  'storeManagement.emailModal.sendCodeSuccess': '验证码已发送，请查收邮件',
  'storeManagement.emailModal.sendCodeFailed': '验证码发送失败',
  'storeManagement.emailModal.verifySuccess': '邮箱配置校验通过，可以保存',
  'storeManagement.emailModal.verifyFailed': '验证码错误或已过期',
  'storeManagement.emailModal.verifyRequired': '请先完成邮箱配置验证',
};
